module.exports = __webpack_public_path__ + "media/images/icon-badge-no1-dbc01465b4f8a15ed1d7111731fc7b6b.svg";